import React from 'react';
import { Page, Table, Tooltip, Icon } from '@trellixio/roaster-coffee';
import Locales from 'locales';

const Test = () => {
  return (
    <Page title="Factures table" size="full">
      <Table>
        <Table.Head>
          <Table.HeadCell type="thumbnail" />
          <Table.HeadCell type="text">{Locales.trip.table.passport}</Table.HeadCell>
          <Table.HeadCell type="text">{Locales.trip.table.npi}</Table.HeadCell>
          <Table.HeadCell type="text">{Locales.trip.table.firstname}</Table.HeadCell>
          <Table.HeadCell type="text">
            {Locales.trip.table.lastname}
            <Tooltip inline label={Locales.trip.table.tooltips.lastname}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="enum">
            {Locales.trip.table.categorie}
            <Tooltip inline label={Locales.trip.table.tooltips.categorie}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="date">
            {Locales.trip.table.birthdate}
            <Tooltip inline label={Locales.trip.table.tooltips.birthdate}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="numeric">
            {Locales.trip.table.deposits}
            <Tooltip inline label={Locales.trip.table.tooltips.deposits}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="numeric">
            {Locales.trip.table.bank}
            <Tooltip inline label={Locales.trip.table.tooltips.bank}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="numeric">
            {Locales.trip.table.total_fees}
            <Tooltip inline label={Locales.trip.table.tooltips.total_fees}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="enum">
            {Locales.trip.table.next_step}
            <Tooltip inline label={Locales.trip.table.tooltips.next_step}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="text">
            {Locales.trip.table.company}
            <Tooltip inline label={Locales.trip.table.tooltips.company}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <>
            <Table.HeadCell type="text">
              {Locales.trip.table.passport_expiration}
              <Tooltip inline label={Locales.trip.table.tooltips.passport_expiration}>
                <Icon hasTooltip>
                  <i className="fa-regular fa-circle-info" />
                </Icon>
              </Tooltip>
            </Table.HeadCell>
            <Table.HeadCell type="text">
              {Locales.trip.table.passport_validation}
              <Tooltip inline label={Locales.trip.table.tooltips.passport_validation}>
                <Icon hasTooltip>
                  <i className="fa-regular fa-circle-info" />
                </Icon>
              </Tooltip>
            </Table.HeadCell>
          </>

          <Table.HeadCell type="text">
            {Locales.trip.table.doctor}
            <Tooltip inline label={Locales.trip.table.tooltips.doctor}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="text">
            {Locales.trip.table.health}
            <Tooltip inline label={Locales.trip.table.tooltips.health}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="text">
            {Locales.trip.table.medical_visit}
            <Tooltip inline label={Locales.trip.table.tooltips.medical_visit}>
              <Icon hasTooltip>
                <i className="fa-regular fa-circle-info" />
              </Icon>
            </Tooltip>
          </Table.HeadCell>

          <Table.HeadCell type="text">{Locales.trip.table.note}</Table.HeadCell>
          <Table.HeadCell type="object">{Locales.trip.table.actions}</Table.HeadCell>
        </Table.Head>
      </Table>
    </Page>
  );
};

export default Test;
